import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import logoImg from '../../assets/img/logo.png'
import { NAV_ITEMS } from '../../data/navigation'
import { ButtonElement, ButtonLocation, trackButtonClick } from '../../utils/analyticsEvents'
import { Icon } from '../Icon/Icon'
import { LanguageSelect } from '../LanguageSelect/LanguageSelect'
import { MobileMenu } from '../MobileMenu/MobileMenu'
import styles from './Header.module.scss'

interface HeaderProps {
  onGetPromo: () => void
}

export const Header = ({ onGetPromo }: HeaderProps) => {
  const { t } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a aria-label={t('header.logoAria')} className={styles.logo} href="#top">
          <img alt="Nova Post" height="42" src={logoImg} width="160" />
        </a>
        <nav aria-label={t('common.mainNavAria')} className={styles.nav}>
          <ul className={styles.tabs}>
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a className={styles.tab} href={item.href}>
                  {t(item.labelKey)}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className={styles.controls}>
          <LanguageSelect className={styles.language} />
          <span className={styles.divider} />
          <button
            className={styles.promo}
            type="button"
            onClick={() => {
              trackButtonClick(ButtonElement.GetPromocode, ButtonLocation.Header)
              onGetPromo()
            }}
          >
            {t('header.getPromo')}
          </button>
          <button
            aria-label={t('header.openMenu')}
            className={styles.burger}
            type="button"
            onClick={() => {
              setMenuOpen(true)
            }}
          >
            <Icon name="burger" size={24} />
          </button>
        </div>
      </div>
      {menuOpen ? (
        <MobileMenu
          onClose={() => {
            setMenuOpen(false)
          }}
          onGetPromo={() => {
            setMenuOpen(false)
            onGetPromo()
          }}
        />
      ) : null}
    </header>
  )
}
